import englishMessages from "ra-language-english";
import {default as persianMessages} from "./fa_IR";
import polyglotI18nProvider from "ra-i18n-polyglot";

export const i18nProvider = polyglotI18nProvider(
  (locale) => (locale === "fa" ? persianMessages : englishMessages),
  "fa"
);
